import React, { useState, useRef, useEffect } from 'react';
import './dropdown.scss';

const NewDropdown = ({ label = '', options = [], onChange = undefined, selectedValue }) => {
    const [isActive, setIsActive] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleDropdownToggle = () => {
        setIsActive(!isActive);
    };

    const handleItemClick = item => {
        setIsActive(false);
        onChange(item);
    };

    return (
        <label className="new-dropdown">
            {label && <div className="new-dropdown__label">{label}</div>}
            <div
                className={`select-input ${isActive ? '-active' : ''} ${!!selectedValue ? '-selected' : ''}`}
                ref={dropdownRef}
            >
                <input type="text" />
                <div className="--dropdown__value" onClick={handleDropdownToggle}>
                    <span className="--dropdown__value-text body1">
                        {!!selectedValue?.name ? (
                            <div>
                                {selectedValue?.icon && <img src={selectedValue?.icon} alt={selectedValue?.name} />}
                                {selectedValue?.name}
                            </div>
                        ) : (
                            <div>
                                <img src={options[0]?.icon} alt={options[0]?.icon} />
                                {options[0]?.name}
                            </div>
                        )}
                    </span>
                </div>
                <ul>
                    {options
                        .filter(el => el?.name !== selectedValue?.name)
                        .map(el => (
                            <li className="body1" onClick={() => handleItemClick(el)} key={el.name}>
                                {el?.icon && <img src={el?.icon} alt={el.name} />}
                                {el.name}
                            </li>
                        ))}
                </ul>
            </div>
        </label>
    );
};

export default NewDropdown;
